import { Fragment } from "react"

import { useBookingContext } from "modules/Booking/BookingContext"
import { useSkipPayment } from "modules/Booking/FormPage/common/hooks"
import { useGetServicePrice } from "modules/Booking/common/hooks"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { Pages } from "modules/BookingCommon/common/constants"
import { useGetCurrentPage } from "modules/Booking/common/hooks/useGetCurrentPage"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"
import { Img, Text } from "ui-kit/components-branded/index"

function Details() {
    const [{ isOnline, sessionType }] = useBookingContext()
    const [, discountPrice] = useGetServicePrice()

    const paymentText = discountPrice === 0 ? "записи" : "оплаты"
    const description = isOnline ? (
        <>Пришлем ссылку на&nbsp;звонок с&nbsp;вашим психологом в&nbsp;смс после {paymentText}.</>
    ) : (
        <>Пришлем адрес сессии с&nbsp;вашим психологом в&nbsp;смс после {paymentText}.</>
    )

    return (
        <>
            {sessionType === SESSION_TYPE.DEFAULT && (
                <div className="booking-details booking-details--is-default">
                    <Text>
                        <Img className="booking-details__emoji" src="mailbox-emoji.png" />
                        {description}
                    </Text>
                </div>
            )}
        </>
    )
}

export function AlterGuaranties() {
    const [{ hasPreviousSessions }] = useBookingContext()
    const skipPayment = useSkipPayment()
    const onlyFree = useOnlyFreeSessions()
    const isForm = useGetCurrentPage() === Pages.FORM

    const components = []

    if (!skipPayment && isForm && !onlyFree && !hasPreviousSessions) {
        components.push(
            <div className="guaranties">
                <div className="guaranties__wrapper">
                    Оплатить сессию можно в&nbsp;течение 20&nbsp;минут. За&nbsp;это время другие
                    клиенты не&nbsp;смогут записаться на&nbsp;ваше время.
                </div>
            </div>
        )
    }

    if (isForm && !hasPreviousSessions) {
        components.push(<Details />)
    }

    return (
        <>
            {components.map((c, i) => (
                <Fragment key={i}>{c}</Fragment>
            ))}
        </>
    )
}
